// extracted by mini-css-extract-plugin
module.exports = {"social":"styles_social__5Uxoj","icon__wrapper":"styles_icon__wrapper__28B7B"};